import axios from 'axios';

const api = axios.create({
    baseURL: '/admin/commission-v2/'
});

export const closedStudents = (user_id, year, month) => api.get(`user/${user_id}/closed-students/${year}/${month}`);
export const previousMonths = (user_id, year, month) => api.get(`user/${user_id}/previous-months/${year}/${month}`);
export const userList = (role_id) => api.get(`user-list/${role_id}`);
export const userPosition = (params) => api.get(`user-position`, { params });
export const availablePeriods = (user_id, year) => api.get(`available-periods/${user_id}/${year}`);
export const totalEarned = (user_id, year, month) => api.get(`total-commissions-earned/${user_id}/${year}/${month}`);
export const acceptCommissions = (user_id, payload) => api.post(`accept-commissions/${user_id}`, payload);
export const processApproval = (commissionable_id, payload) => api.post(`process-approval/${commissionable_id}`, payload);
export const processPossibleCommission = (user_id, payment_plan) => api.post(`process-possible-commission/${user_id}/${payment_plan}`);
export const addTransaction = (commission_id, payload) => api.post(`transaction/${commission_id}`, payload);
export const updateTransaction = (commission_id, payload) => api.put(`transaction/${commission_id}`, payload);
export const deleteTransaction = (commission_id) => api.delete(`transaction/${commission_id}`);
export const deleteCommission = (commission_id) => api.delete(`commission/${commission_id}`);
export const paymentSettings = {
    list: (user_id) => api.get(`user/${user_id}/payment-settings/list`),
    active: (user_id, year, month) => api.get(`user/${user_id}/payment-settings/active/${year}/${month}`),
    details: (user_id, setting_id) => api.get(`user/${user_id}/payment-settings/details/${setting_id}`),
    create: (user_id, payload) => api.post(`user/${user_id}/payment-settings/create`, payload),
    update: (user_id, setting_id, payload) => api.put(`user/${user_id}/payment-settings/update/${setting_id}`, payload),
    delete: (user_id, setting_id) => api.delete(`user/${user_id}/payment-settings/delete/${setting_id}`)
};